import React, { useContext, useEffect, useRef } from "react";
import "../About/about.css";
import { DataContext } from "../contextAPI";
import autocad from "../images/autocad.png";
import Photoshop from "../images/photoshop.png";
import Figma from "../images/Figma.png";
import Slideshow from "../Slider/Slider";
import Grids from "./Grids";
import designThinking from "../images/designThinking.png";
import ui from "../images/ui.png";
import webOptimization from "../images/webOptimization.png";
import collaboration from "../images/collaboration.png";

const About = () => {
  const { isIntersecting, setIsIntersecting, toggleMode, setToggleMode } =
    useContext(DataContext);

  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      },
      { rootMargin: "-300px" }
    );
    console.log(isIntersecting);
    observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const elements = ref.current.querySelectorAll("div");

    if (isIntersecting) {
      elements.forEach((el, index) => {
        // Add delay classes for staggered animation
        el.classList.add("animate", "delay-" + (index + 1));
      });
    } else {
      elements.forEach((el) => {
        el.classList.remove(
          "animate",
          "delay-1",
          "delay-2",
          "delay-3",
          "delay-4"
        );
      });
    }
  }, [isIntersecting]);

  return (
    <div className={`  ${toggleMode ? "theme" : "dark-mode"}`}>
      <div className="overall-container " id="About" ref={ref}>
        <div
          className={`span_1_of_5 span_1_of_4  ${
            toggleMode ? "theme" : "dark-mode"
          }`}
        >
          <Slideshow />
        </div>
        <div className="span_1_of_3 gradient-cards">
          <Grids
            icon={
              <h1>
                <img src={ui} alt="" width="45" height="45" />
              </h1>
            }
            title="UI/UX"
            body="Crafting intuitive interfaces and user experiences with a focus on user-centric design principles to elevate interactions"
            className="animate pop "
          />
          <Grids
            icon={
              <h1>
                <img src={designThinking} alt="" width="45" height="45" />
              </h1>
            }
            title="Creativity"
            body="Injecting creativity into problem-solving, innovating solutions, and adding unique touches for impactful applications."
            className="animate pop delay-1"
          />
          <Grids
            icon={
              <h1>
                <img src={webOptimization} alt="" width="45" height="45" />
              </h1>
            }
            title="Development"
            body="Comprehensive full stack proficiency—building responsive designs and robust server-side functionalities for seamless integration."
            className="animate pop delay-2"
          />
          <Grids
            icon={
              <h1>
                <img src={collaboration} alt="" width="45" height="45" />
              </h1>
            }
            title="Collaborations"
            body="Thriving in collaborative environments, adept at fostering teamwork, communication, and achieving collective project success."
            className="animate pop delay-3"
          />
        </div>
      </div>
      <div className="middle-tap section">
        <div className="apps-wrapper">
          <img
            src={autocad}
            className="apps-logo"
            alt="Girl in a jacket"
            width="100"
            height="100"
          ></img>
          <img
            className="apps-logo"
            src={Figma}
            alt="Girl in a jacket"
            width="100"
            height="100"
          ></img>
          <img
            className="apps-logo"
            src={Photoshop}
            alt="Girl in a jacket"
            width="100"
            height="100"
          ></img>
        </div>
      </div>
    </div>
  );
};

export default About;
